import {
  Avatar,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Row,
  Select,
  Switch,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import ProfileMenu from '../../../components/ProfileMenu';
import Layout from '../../../layouts/User';
import {
  getCities,
  getPostalCodes,
  getStates,
  getSubCities,
} from '../../../services/api/index';
import styles from './index.module.scss';

const Home: React.FC = () => {
  let [formAddress] = Form.useForm();
  const user = useSelector((state: any) => state.user);
  const [currentUser, setCurrentUser] = useState<any>({});
  const [profileImage, setProfileImage] = useState<any>('');
  const [profileName, setProfileName] = useState<any>('');
  const [postalCodes, setPostalCodes] = useState<any>([]);
  const [state, setState] = useState<any>({
    addresses: [
      {
        address: null,
        subCity: null,
        city: null,
        state: null,
        postalCode: null,
        isCurrent: false,
      },
    ],
  });
  const [subCitiesArray, setSubCitiesArray] = useState<any>([]);
  const [citiesArray, setCitiesArray] = useState<any>([]);
  const [statesArray, setStatesArray] = useState<any>([]);

  const breadcrumbs = [
    {
      text: 'หน้าหลัก',
      path: '/',
    },
    {
      text: 'ข้อมูลของฉัน',
    },
  ];
  // --------------------------------------------------------------------------------------------------------
  // SELECT CURRENT ADDRESS
  const selectCurrentAddress = (index: any) => {
    const setCurrentAddress = [];
    if (state?.addresses?.length) {
      for (let i = 0; i < state?.addresses?.length; i++) {
        setCurrentAddress.push({ ...state.addresses[i], isCurrent: false });
      }
      setCurrentAddress[index].isCurrent = true;
    }
    setState({ addresses: setCurrentAddress });
  };

  // --------------------------------------------------------------------------------------------------------
  // ADDRESS POSTALCODE SUBCITY CITY STATE API
  const getPostalCodesAPI = async () => {
    setPostalCodes(await getPostalCodes());
  };
  // const getOnPostalCodeChange = async (value: any) => {
  //   if (value) {
  //     // setSubCities(await getSubCities(value));
  //   } else {
  //     formAddress.setFieldsValue({
  //       subCity: null,
  //       city: null,
  //       state: null,
  //     });
  //   }
  // };
  const onPostalCodeChange = async (value: any, index: any) => {
    if (value) {
      const subCitiesByPostalCode = { subCities: await getSubCities(value) };
      let setsubCitiesByPostalCodeArray = subCitiesArray;
      setsubCitiesByPostalCodeArray[index] = subCitiesByPostalCode;
      setSubCitiesArray([]);
      setSubCitiesArray(setsubCitiesByPostalCodeArray);
      let addresses = state.addresses;
      addresses[index] = {
        address: addresses[index].address,
        postalCode: value,
        subCity: null,
        city: null,
        state: null,
        isCurrent: addresses[index].isCurrent,
      };
      setState({ addresses: addresses });
    }
  };
  const setOnPostalCodeChange = async (value: any) => {
    if (value) {
      const subCitiesByPostalCode = { subCities: await getSubCities(value) };
      let setsubCitiesByPostalCodeArray = subCitiesArray;

      setsubCitiesByPostalCodeArray.push(subCitiesByPostalCode);
      setSubCitiesArray([]);
      setSubCitiesArray(setsubCitiesByPostalCodeArray);
    }
  };

  const onSubCityChange = async (value: any, index: any) => {
    const citiesByPostalCode = { cities: await getCities(value) };
    let setCitiesByPostalCodeArray = citiesArray;
    setCitiesByPostalCodeArray[index] = citiesByPostalCode;
    setCitiesArray([]);
    setCitiesArray(setCitiesByPostalCodeArray);

    let addresses = state.addresses;

    addresses[index] = {
      address: addresses[index].address,
      postalCode: addresses[index].postalCode,
      subCity: value,
      city: null,
      state: null,
      isCurrent: addresses[index].isCurrent,
    };
    setState({ addresses: addresses });
  };
  const setOnSubCityChange = async (value: any) => {
    if (value) {
      const citiesByPostalCode = { cities: await getCities(value) };
      let setCitiesBySubCitiesArray = citiesArray;

      setCitiesBySubCitiesArray.push(citiesByPostalCode);
      setCitiesArray([]);
      setCitiesArray(setCitiesBySubCitiesArray);
    }
  };
  const onCityChange = async (value: any, index: any) => {
    const statesByCities = { states: await getStates(value) };

    let setStatesByCitiesArray = statesArray;
    setStatesByCitiesArray[index] = statesByCities;
    // console.log("setCitiesByPostalCodeArray", setStatesByCitiesArray);
    setStatesArray([]);
    setStatesArray(setStatesByCitiesArray);

    let addresses = state.addresses;

    addresses[index] = {
      address: addresses[index].address,
      postalCode: addresses[index].postalCode,
      subCity: addresses[index].subCity,
      city: value,
      state: null,
      isCurrent: addresses[index].isCurrent,
    };
    setState({ addresses: addresses });
  };

  const setOnCityChange = async (value: any) => {
    if (value) {
      const statesByCities = { states: await getStates(value) };
      let setStatesByCitiesArray = statesArray;

      setStatesByCitiesArray.push(statesByCities);
      setStatesArray([]);
      setStatesArray(setStatesByCitiesArray);
    }
  };

  const onStatesChange = async (value: any, index: any) => {
    let addresses = state.addresses;

    addresses[index] = {
      address: addresses[index].address,
      postalCode: addresses[index].postalCode,
      subCity: addresses[index].subCity,
      city: addresses[index].city,
      state: value,
      isCurrent: addresses[index].isCurrent,
    };
    setState({ addresses: addresses });
  };

  // --------------------------------------------------------------------------------------------------------
  // ADD & REMOVE ADDRESS
  const onAddAddresses = () => {
    const addressesArray = formAddress.getFieldValue('addresses');
    const value = { addresses: addressesArray };
    value.addresses.push({
      address: null,
      subCity: null,
      city: null,
      state: null,
      postalCode: null,
      isCurrent: false,
    });
    let array1 = [];
    for (let i = 0; i < value?.addresses?.length; i++) {
      let obj = value.addresses[i];
      if (obj !== undefined) {
        array1.push(obj);
      }
    }
    let array = { addresses: array1 };
    setState(array);
  };
  const onDelete = (index: any) => {
    let addresses = state.addresses;

    addresses.splice(index, 1);

    setState({
      ...state,
      addresses,
    });
  };
  // --------------------------------------------------------------------------------------------------------
  // SUBMIT
  const confirmButton = async (values: any) => {
    await axios.patch(`/users/${currentUser._id}`, values);
    window.location.reload();
  };
  // --------------------------------------------------------------------------------------------------------

  const setAddresses = async () => {
    const addresses = [];
    for (let i = 0; i < currentUser?.addresses?.length; i++) {
      await setOnPostalCodeChange(currentUser?.addresses[i]?.postalCode?.name);
      if (i === currentUser?.addresses?.length - 1) {
        if (subCitiesArray.length) {
          for (let j = 0; j < subCitiesArray.length; j++) {
            await setOnSubCityChange(currentUser?.addresses[j]?.subCity?._id);
          }
        }
      }
      addresses.push({
        address: currentUser?.addresses[i]?.address,
        postalCode: currentUser?.addresses[i]?.postalCode?.name,
        subCity: currentUser?.addresses[i]?.subCity?._id,
        city: currentUser?.addresses[i]?.city?._id,
        state: currentUser?.addresses[i]?.state?._id,
        isCurrent: currentUser?.addresses[i]?.isCurrent,
      });
    }
    setState({ addresses: addresses });
  };

  const addressAdd = (value: any, index: any) => {
    let addresses = state.addresses;

    addresses[index] = {
      address: value,
      postalCode: addresses[index].postalCode,
      subCity: addresses[index].subCity,
      city: addresses[index].city,
      state: addresses[index].state,
      isCurrent: addresses[index].isCurrent,
    };
    setState({ addresses: addresses });
  };

  useEffect(() => {
    formAddress.setFieldsValue({ ...state });
  }, [state]);

  useEffect(() => {
    setCurrentUser(user);
  }, [user]);

  useEffect(() => {
    if (currentUser._id) {
      setProfileImage(currentUser.photoURL);
      setProfileName(currentUser.displayName);
      // getOnPostalCodeChange(currentUser?.addresses[0]?.postalCode?.name);
      getPostalCodesAPI();

      if (currentUser._id) {
        setAddresses();
      }
    }
  }, [currentUser]);

  useEffect(() => {
    formAddress.setFieldsValue({
      addresses: [{}],
    });
  }, []);

  useEffect(() => {
    if (citiesArray.length) {
      for (let i = 0; i < citiesArray.length; i++) {
        if (i === citiesArray.length - 1) {
          setOnCityChange(currentUser?.addresses[i]?.city?._id);
        }
      }
    }
  }, [citiesArray]);
  return (
    <>
      <div>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} className={`${styles.field}`}>
            <div className={styles.header}>ที่อยู่ของฉัน</div>
            <Divider
              style={{ background: 'black', margin: '15px 0' }}
            ></Divider>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={12}
            lg={12}
            className={`${styles.field} ${styles.right}`}
          ></Col>
        </Row>
        <Form form={formAddress} onFinish={confirmButton} layout='vertical'>
          <Form.List name='addresses'>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, fieldKey, ...restField }: any) => (
                  <Row key={key}>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'address']}
                        fieldKey={[fieldKey, 'address']}
                        label={`รายละเอียดที่อยู่`}
                        rules={[
                          {
                            required: false,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <TextArea
                          onChange={(e) => {
                            addressAdd(e.target.value, name);
                          }}
                          style={{ width: '100%' }}
                          name='address'
                          value={`address`}
                          placeholder='รายละเอียดที่อยู่'
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'postalCode']}
                        fieldKey={[fieldKey, 'postalCode']}
                        label={`รหัสไปรษณีย์`}
                        rules={[
                          {
                            required: false,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          showSearch
                          onChange={(e) => onPostalCodeChange(e, name)}
                          options={postalCodes}
                          placeholder='รหัสไปรษณีย์'
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'subCity']}
                        fieldKey={[fieldKey, 'subCity']}
                        label={`แขวง / ตำบล`}
                        rules={[
                          {
                            required: false,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          onChange={(e) => onSubCityChange(e, name)}
                          options={
                            subCitiesArray[name]?.subCities
                              ? subCitiesArray[name]?.subCities
                              : null
                          }
                          showSearch
                          filterOption={(input, option: any) =>
                            option.label.indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder='แขวง / ตำบล'
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'city']}
                        fieldKey={[fieldKey, 'city']}
                        label={`เขต / อำเภอ`}
                        rules={[
                          {
                            required: false,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          onChange={(e) => onCityChange(e, name)}
                          options={
                            citiesArray[name]?.cities
                              ? citiesArray[name]?.cities
                              : null
                          }
                          showSearch
                          filterOption={(input, option: any) =>
                            option.label.indexOf(input.toLowerCase()) >= 0
                          }
                          placeholder='เขต / อำเภอ'
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'state']}
                        fieldKey={[fieldKey, 'state']}
                        label={`จังหวัด`}
                        rules={[
                          {
                            required: false,
                            message: 'กรุณากรอกข้อมูล!',
                          },
                        ]}
                      >
                        <Select
                          onChange={(e) => {
                            onStatesChange(e, name);
                          }}
                          options={
                            statesArray[name]?.states
                              ? statesArray[name]?.states
                              : null
                          }
                          placeholder='จังหวัด'
                        ></Select>
                      </Form.Item>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={`${styles.field}`}
                    >
                      <Form.Item
                        {...restField}
                        name={[name, 'isCurrent']}
                        fieldKey={[fieldKey, 'isCurrent']}
                        label={`เลือกเป็นที่อยู่ปัจจุบัน`}
                      >
                        <Switch
                          onClick={() => {
                            selectCurrentAddress(name);
                          }}
                          checked={state?.addresses[name]?.isCurrent}
                        />
                      </Form.Item>
                    </Col>
                    <Col
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      className={`${[styles.field].join(' ')}`}
                      style={{ paddingTop: 30 }}
                    >
                      {state.addresses.length > 1 && (
                        <>
                          <a
                            className={`${[styles.topBody].join(' ')}`}
                            onClick={() => {
                              remove(name);
                              onDelete(name);
                            }}
                          >
                            <img src='/images/delete_24px_rounded.svg' />
                            <span
                              style={{
                                paddingTop: 10,
                                color: '#000000',
                              }}
                            >
                              ลบที่อยู่
                            </span>
                          </a>
                        </>
                      )}
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      className={`${styles.field}`}
                    >
                      <Divider
                        style={{
                          background: 'black',
                          margin: '15px 0',
                        }}
                      ></Divider>
                    </Col>
                  </Row>
                ))}
                <Row>
                  <Col span={24} className={`${styles.topBody}`}>
                    <Button
                      onClick={() => {
                        add();
                        onAddAddresses();
                      }}
                      className={`${styles.addAddressButton}`}
                    >
                      เพิ่มที่อยู่
                    </Button>
                    <Button
                      htmlType='submit'
                      className={`${styles.confirmButton}`}
                    >
                      บันทึก
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Form.List>
        </Form>
      </div>
    </>
  );
};

export default Home;
